import { connect } from 'react-redux';

import BuildPageChartContainer from './/BuildPageChartContainer.jsx';
import { getSourceCountsMetricsInfo } from './../reducers';

export const mapStateToProps = (state) => {
  const metricsInfo = getSourceCountsMetricsInfo(state);
  metricsInfo.metrics = metricsInfo.metrics.map(m => m.sourceCountDiff);

  return {
    title: 'Source Count Difference',
    metricsInfo
  };
};

export default connect(
  mapStateToProps
)(BuildPageChartContainer);


// WEBPACK FOOTER //
// src/Containers/SourceCountChartContainer.jsx